<template>
    <div class="web-instructions">
        <iframe :src="docId" frameborder="0"></iframe>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { uncompileStr } from "@/utils/util";
export default {
    name: "instructions",
    data() {
        return {
            docId: null
        };
    },
    computed: {
        //...mapState("mixins", ["currentDoc"])
    },
    mounted() {
        this.$store.state.mixins.triggerSideNavShow = false;
        let id = uncompileStr(this.$route.query.docId);
        this.docId = `https://docs.google.com/document/d/${id}/edit?usp=sharing`;
    },
    methods: {}
};
</script>

<style lang="scss">
body[data-slug="instructions"] {
    .v-application--wrap {
        position: relative;
        height: calc(100vh - 64px);
        overflow: hidden;
    }
}

.web-instructions {
    height: 100vh;
    width: 100vw;

    iframe {
        height: calc(100vh + 16px);
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        top: -80px;
    }
}
</style>
